var _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _path, _line11, _path2, _line12, _line13, _line14, _line15, _line16, _line17, _line18, _line19, _line20, _line21, _line22, _line23, _path3, _line24, _line25, _line26, _path4, _line27, _line28, _line29, _line30, _line31, _line32, _line33, _path5, _line34, _path6, _line35, _line36, _line37, _line38, _line39, _line40, _line41, _line42, _line43, _line44, _line45, _line46, _line47, _line48, _path7, _path8, _path9, _path10, _line49, _line50, _line51, _line52, _line53, _line54, _line55, _line56, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _line57, _line58, _line59, _line60, _line61, _line62, _line63, _line64, _line65, _line66, _line67, _line68, _line69, _line70, _line71, _line72, _line73, _line74, _line75, _line76, _line77, _line78;

var _excluded = ["svgRef", "title"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var SvgYope = function SvgYope(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "616.0mm",
    height: "368.0mm",
    viewBox: "0.0 0.0 616.0 368.0",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 17,
    y1: 81,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 17,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 0,
    y1: 157,
    y2: 114.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 81,
    y2: 114.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 266,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 266,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 268,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 317,
    y1: 79,
    y2: 77.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 317,
    y1: 72.5,
    y2: 77.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 342,
    x2: 317,
    y1: 19.5,
    y2: 72.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 342 19.5 c 1.95 -13 6.5 -19.5 19.5 -19.5"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 361.5,
    x2: 472.5,
    y1: 0,
    y2: 0,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 492 19.5 c -1.95 -13 -6.5 -19.5 -19.5 -19.5"
  })), _line12 || (_line12 = /*#__PURE__*/React.createElement("line", {
    x1: 492,
    x2: 517,
    y1: 19.5,
    y2: 72.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line13 || (_line13 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 517,
    y1: 77.5,
    y2: 72.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line14 || (_line14 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 517,
    y1: 79,
    y2: 77.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line15 || (_line15 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 566,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line16 || (_line16 = /*#__PURE__*/React.createElement("line", {
    x1: 568,
    x2: 566,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line17 || (_line17 = /*#__PURE__*/React.createElement("line", {
    x1: 616,
    x2: 568,
    y1: 79,
    y2: 79,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line18 || (_line18 = /*#__PURE__*/React.createElement("line", {
    x1: 616,
    x2: 616,
    y1: 79,
    y2: 157,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line19 || (_line19 = /*#__PURE__*/React.createElement("line", {
    x1: 616,
    x2: 616,
    y1: 159,
    y2: 157,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line20 || (_line20 = /*#__PURE__*/React.createElement("line", {
    x1: 616,
    x2: 616,
    y1: 159,
    y2: 279,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line21 || (_line21 = /*#__PURE__*/React.createElement("line", {
    x1: 614,
    x2: 616,
    y1: 283,
    y2: 279,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line22 || (_line22 = /*#__PURE__*/React.createElement("line", {
    x1: 614,
    x2: 614,
    y1: 368,
    y2: 283,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line23 || (_line23 = /*#__PURE__*/React.createElement("line", {
    x1: 555,
    x2: 614,
    y1: 368,
    y2: 368,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 555 368 C 555 352.5 567 337 567 337"
  })), _line24 || (_line24 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 567,
    y1: 279,
    y2: 337,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line25 || (_line25 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 517,
    y1: 283,
    y2: 279,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line26 || (_line26 = /*#__PURE__*/React.createElement("line", {
    x1: 515,
    x2: 515,
    y1: 283,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 515 328 C 515 343.5 515 359 513 359"
  })), _line27 || (_line27 = /*#__PURE__*/React.createElement("line", {
    x1: 460,
    x2: 513,
    y1: 359,
    y2: 359,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line28 || (_line28 = /*#__PURE__*/React.createElement("line", {
    x1: 460,
    x2: 460,
    y1: 328,
    y2: 359,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line29 || (_line29 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    x2: 460,
    y1: 328,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line30 || (_line30 = /*#__PURE__*/React.createElement("line", {
    x1: 374,
    x2: 374,
    y1: 359,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line31 || (_line31 = /*#__PURE__*/React.createElement("line", {
    x1: 321,
    x2: 374,
    y1: 359,
    y2: 359,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line32 || (_line32 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 319,
    y1: 279,
    y2: 283,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line33 || (_line33 = /*#__PURE__*/React.createElement("line", {
    x1: 319,
    x2: 319,
    y1: 283,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 319 328 C 319 343.5 319 359 321 359"
  })), _line34 || (_line34 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 267,
    y1: 279,
    y2: 337,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 279 368 C 279 352.5 267 337 267 337"
  })), _line35 || (_line35 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    x2: 279,
    y1: 368,
    y2: 368,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line36 || (_line36 = /*#__PURE__*/React.createElement("line", {
    x1: 220,
    x2: 220,
    y1: 283,
    y2: 368,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line37 || (_line37 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 220,
    y1: 279,
    y2: 283,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line38 || (_line38 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 159,
    y1: 279,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line39 || (_line39 = /*#__PURE__*/React.createElement("line", {
    x1: 156,
    x2: 159,
    y1: 359,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line40 || (_line40 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    x2: 78,
    y1: 328,
    y2: 359,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line41 || (_line41 = /*#__PURE__*/React.createElement("line", {
    x1: 156,
    x2: 78,
    y1: 359,
    y2: 359,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line42 || (_line42 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 75,
    y1: 279,
    y2: 328,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line43 || (_line43 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 17,
    y1: 277,
    y2: 279,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line44 || (_line44 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 0,
    y1: 163,
    y2: 277,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line45 || (_line45 = /*#__PURE__*/React.createElement("line", {
    x1: 0,
    x2: 17,
    y1: 163,
    y2: 161,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line46 || (_line46 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 17,
    y1: 157,
    y2: 161,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line47 || (_line47 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    x2: 159,
    y1: 94,
    y2: 94,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line48 || (_line48 = /*#__PURE__*/React.createElement("line", {
    x1: 75,
    x2: 159,
    y1: 114,
    y2: 114,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 65 104 c 0 6.006 5 10 10 10"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 65 104 c 0 -6.0606 5 -10 10 -10"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 169 104 c 0 -6.006 -5 -10 -10 -10"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 169 104 c 0 6.006 -5 10 -10 10"
  })), _line49 || (_line49 = /*#__PURE__*/React.createElement("line", {
    x1: 101.14999999999998,
    x2: 132.85000000000002,
    y1: 129.5,
    y2: 129.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line50 || (_line50 = /*#__PURE__*/React.createElement("line", {
    x1: 100.14999999999998,
    x2: 133.85000000000002,
    y1: 132.5,
    y2: 132.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line51 || (_line51 = /*#__PURE__*/React.createElement("line", {
    x1: 101.14999999999998,
    x2: 100.14999999999998,
    y1: 129.5,
    y2: 132.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line52 || (_line52 = /*#__PURE__*/React.createElement("line", {
    x1: 132.85000000000002,
    x2: 133.85000000000002,
    y1: 129.5,
    y2: 132.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line53 || (_line53 = /*#__PURE__*/React.createElement("line", {
    x1: 375,
    x2: 459,
    y1: 35.5,
    y2: 35.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line54 || (_line54 = /*#__PURE__*/React.createElement("line", {
    x1: 375,
    x2: 459,
    y1: 55.5,
    y2: 55.5,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line55 || (_line55 = /*#__PURE__*/React.createElement("line", {
    x1: 375,
    x2: 459,
    y1: 94,
    y2: 94,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _line56 || (_line56 = /*#__PURE__*/React.createElement("line", {
    x1: 375,
    x2: 459,
    y1: 114,
    y2: 114,
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 469 45.5 c 0 -6.006 -5 -10 -10 -10"
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 469 45.5 c 0 6.006 -5 10 -10 10"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 365 45.5 c 0 -6.006 5 -10 10 -10"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 365 45.5 c 0 6.006 5 10 10 10"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 469 104 c 0 -6.006 -5 -10 -10 -10"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 469 104 c 0 6.006 -5 10 -10 10"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 365 104 c 0 -6.006 5 -10 10 -10"
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 365 104 c 0 6.006 5 10 10 10"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 402.15 19.5 c 0 5 5.94 10 14.85 10"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    fill: "none",
    stroke: "black",
    strokeWidth: 0.5,
    d: "M 431.85 19.5 c 0 5 -5.94 10 -14.85 10"
  })), _line57 || (_line57 = /*#__PURE__*/React.createElement("line", {
    x1: 492,
    x2: 431.85,
    y1: 19.5,
    y2: 19.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line58 || (_line58 = /*#__PURE__*/React.createElement("line", {
    x1: 342,
    x2: 402.15,
    y1: 19.5,
    y2: 19.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line59 || (_line59 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 517,
    y1: 72.5,
    y2: 72.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line60 || (_line60 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 517,
    y1: 77.5,
    y2: 77.5,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line61 || (_line61 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 17,
    y1: 161,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line62 || (_line62 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 217,
    y1: 279,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line63 || (_line63 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 317,
    y1: 279,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line64 || (_line64 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 317,
    y1: 279,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line65 || (_line65 = /*#__PURE__*/React.createElement("line", {
    x1: 616,
    x2: 517,
    y1: 279,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line66 || (_line66 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 517,
    y1: 159,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line67 || (_line67 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 517,
    y1: 79,
    y2: 159,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line68 || (_line68 = /*#__PURE__*/React.createElement("line", {
    x1: 566,
    x2: 517,
    y1: 79,
    y2: 159,
    fill: "none",
    stroke: "#cd00ff",
    strokeDasharray: "10 10",
    strokeWidth: 0.5
  })), _line69 || (_line69 = /*#__PURE__*/React.createElement("line", {
    x1: 568,
    x2: 616,
    y1: 79,
    y2: 157,
    fill: "none",
    stroke: "#cd00ff",
    strokeDasharray: "10 10",
    strokeWidth: 0.5
  })), _line70 || (_line70 = /*#__PURE__*/React.createElement("line", {
    x1: 517,
    x2: 616,
    y1: 159,
    y2: 159,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line71 || (_line71 = /*#__PURE__*/React.createElement("line", {
    x1: 17,
    x2: 17,
    y1: 79,
    y2: 157,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line72 || (_line72 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 317,
    y1: 159,
    y2: 159,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line73 || (_line73 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 317,
    y1: 79,
    y2: 159,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line74 || (_line74 = /*#__PURE__*/React.createElement("line", {
    x1: 317,
    x2: 317,
    y1: 159,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line75 || (_line75 = /*#__PURE__*/React.createElement("line", {
    x1: 266,
    x2: 217,
    y1: 79,
    y2: 159,
    fill: "none",
    stroke: "#cd00ff",
    strokeDasharray: "10 10",
    strokeWidth: 0.5
  })), _line76 || (_line76 = /*#__PURE__*/React.createElement("line", {
    x1: 268,
    x2: 317,
    y1: 79,
    y2: 159,
    fill: "none",
    stroke: "#cd00ff",
    strokeDasharray: "10 10",
    strokeWidth: 0.5
  })), _line77 || (_line77 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 217,
    y1: 159,
    y2: 279,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })), _line78 || (_line78 = /*#__PURE__*/React.createElement("line", {
    x1: 217,
    x2: 217,
    y1: 79,
    y2: 159,
    fill: "none",
    stroke: "red",
    strokeWidth: 0.5
  })));
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgYope, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/yope.a157c25e.svg";
export { ForwardRef as ReactComponent };